import QRCode from 'qrcode';
import {ROUTES} from "../../../../constants/routes-path";

export async function generateQrCodeBase64(content, opts) {
    try {
        return QRCode.toDataURL(content, opts);
    } catch (err) {
        console.error('Erro ao gerar QRCode', err);
        return '';
    }
}

export async function generateQrCodeSne(): Promise<string> {
    return QRCode.toDataURL('https://servicos.serpro.gov.br/sne', {
        width: 100,
        margin: 1,
        errorCorrectionLevel: 'L',
    });
}

export async function qrCodeComponent(params) {
    const qrCode = await generateQrCodeBase64(
        `${window.location.origin}${ROUTES.permitteePrintDocumentBatchPdf.replace(":codes", params.code).replace(":id", params.id)}`,
        {
            type: 'svg',
            errorCorrectionLevel: 'L',
            margin: 1,
        }
    )
    return `
    <div
        style="display: flex; justify-content: ${params.position === 'left' ? 'flex-start' : 'flex-end'}">
        <img src="${qrCode}" style="width:1.29in;height:1.29in" alt="QRCode"/>
    </div>
    `;
}

export async function qrCodeLicenseComponent(params) {
    const qrCode = await generateQrCodeBase64(
        `${window.location.origin}${ROUTES.permitteeValidateLicensePath.replace(":code", params.code)}`,
        {
            type: 'svg',
            errorCorrectionLevel: 'L',
            margin: 1,
        }
    )
    return `<img style="position:absolute;top:11.17in;left:${params.position == 'left' ? '0.18' : '7.52' }in;width:1.29in;height:1.29in"
            src="${qrCode}" />
    `;
}
